import { FiMonitor } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2.jsx';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import { param } from '@/redux/selectors/uiSelectors.js';
import { useMemo } from 'react';

const BLACKLISTED_ROUTES = ['/signup', '/login', '/oauth', '/sso-callback', '/go-to-mindcloud', '/tutorial-auth', '/tutorial-webhook'];

const PlatformMobileBanner = () => {
  const workflowId = useArgSelector(param, 'workflowId');
  const appId = useArgSelector(param, 'appId');
  const jobId = useArgSelector(param, 'jobId');
  const isBlacklistedRoute = useMemo(() => BLACKLISTED_ROUTES.some((route) => window.location.pathname.includes(route)), [window.location.pathname]);
  const isInSubPage = useMemo(() => workflowId || appId || jobId, [workflowId, appId, jobId]);

  if (isBlacklistedRoute || !isInSubPage) {
    return null;
  }

  return (
    <div className={`platform-mobile-banner`}>
      <IconV2 icon={FiMonitor} />
      <p>For the complete MindCloud experience, please switch to desktop.</p>
    </div>
  );
};

export default PlatformMobileBanner;
